<script lang="ts" setup>
import { defineAsyncComponent, onMounted, ref } from 'vue'
import { useRuntimeConfig } from '#imports'
import LoadingSpin from '~common/loading-spin.vue'
import ProvidersFilter from '~/components/desktop/pages/common/providers-filter.vue'
import BaseDropdown from '~/components/common/base-dropdown.vue'
import SearchForm from '~/components/common/search-form.vue'
import CasinoItem from '~common/casino/casino-item.vue'
import LoadMoreButton from '~/components/desktop/pages/common/load-more-button.vue'
import LiveStream from '~/components/common/casino/live-stream.vue'
import NoData from '~common/casino/no-data.vue'
import { useCasino } from '~/composables/casino/use-casino'
import { useScrollIntoView } from '~/utils'

const MainMenuTab = defineAsyncComponent(async () => await import('../home/main-menu-tab.vue'))

const config = useRuntimeConfig()
const {
  limit,
  provider,
  category,
  loadMore,
  providers,
  categories,
  totalGames,
  gamesToShow,
  loadingClass,
  keywordSearch,
  indirectGames,
  selectProvider,
  selectCategory,
  playCasinoGame,
  playGameIndirect
} = useCasino()

const casinoRef = ref<HTMLDivElement | null>()

onMounted(() => {
  setTimeout(() => {
    useScrollIntoView(casinoRef.value)
  }, 100)
})
</script>

<template>
  <section ref="casinoRef" class="live-casino">
    <MainMenuTab />

    <div class="container">
      <LoadingSpin v-if="loadingClass" />

      <template v-else>
        <div class="live-casino__content">
          <div class="live-casino__filters">
            <div class="live-casino__filters__provider">
              <ProvidersFilter :providers="providers" :selectedProvider="provider" @select="selectProvider" />
            </div>

            <div class="group-left">
              <BaseDropdown
                class="live-casino__filters__category"
                :valueSelected="category"
                :optionItems="categories"
                @handleItemSelected="({ value }) => selectCategory(value)"
              />
              <SearchForm v-model="keywordSearch" />
            </div>
          </div>

          <template v-if="gamesToShow.length">
            <div class="live-casino__games">
              <div v-for="(game, index) in gamesToShow" :key="index" class="live-casino__games__item">
                <CasinoItem v-if="game" :item="game" :playCasinoGame="playCasinoGame" />
              </div>
            </div>

            <LoadMoreButton :limit="limit" :total="totalGames" @loadMore="loadMore" />
          </template>

          <NoData
            v-else
            :description="keywordSearch ? 'Không tìm thấy kết quả nào phù hợp!' : 'Danh sách game đang được bảo trì'"
          />
        </div>

        <LiveStream />

        <h2 class="live-casino__intermediate__title">CASINO TẠI {{ config.public.INDIRECT_BRAND_NAME }}</h2>
        <div class="live-casino__intermediate">
          <div
            v-for="(item, index) in indirectGames"
            :key="index"
            :class="['live-casino__intermediate--item', item?.class]"
            @click="playGameIndirect(item.url)"
          >
            <div class="ratio">
              <NuxtImg :src="item?.img?.thumbnail?.url" :alt="item?.title" />
            </div>
            <div class="live-casino__intermediate--title">{{ item.title }}</div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/casino/index.scss';
</style>
